import { UnitType } from '../..';

export const uomLinearUnits: UnitType[] = [
  {
    id: 'Linear',
    units: [
      {
        name: 'Centimeter',
        symbol: 'cm',
        aliases: ['cm', 'centimeter', 'centimeters'],
        isNativeUnit: false,
        factorToNative: 0.01,
        offsetToNative: 0.0,
      },
      {
        name: 'Decimeter',
        symbol: 'dm',
        aliases: ['dm', 'decimeter', 'decimeters'],
        isNativeUnit: false,
        factorToNative: 0.1,
        offsetToNative: 0.0,
      },
      {
        name: 'Inch',
        symbol: 'in',
        aliases: ['in', 'inch', 'inches'],
        isNativeUnit: false,
        factorToNative: 0.0254,
        offsetToNative: 0.0,
      },
      {
        name: 'FractionalFoot',
        symbol: 'ft-in',
        aliases: ['fractionalfoot', 'ft-in'],
        isNativeUnit: false,
        factorToNative: 0.0254,
        offsetToNative: 0.0,
      },
      {
        name: 'InternationalFoot',
        symbol: 'ft',
        aliases: ['internationalfoot', 'ft', 'foot', 'feet'],
        isNativeUnit: false,
        factorToNative: 0.3048,
        offsetToNative: 0.0,
      },
      {
        name: 'Kilometer',
        symbol: 'km',
        aliases: ['km', 'kilometer', 'kilometers'],
        isNativeUnit: false,
        factorToNative: 1000.0,
        offsetToNative: 0.0,
      },
      {
        name: 'Meter',
        symbol: 'm',
        aliases: ['m', 'meter', 'meters'],
        isNativeUnit: true,
        factorToNative: 1.0,
        offsetToNative: 0.0,
      },
      {
        name: 'Micrometer',
        symbol: 'µm',
        aliases: ['µm', 'micrometer', 'micrometers'],
        isNativeUnit: false,
        factorToNative: 1e-6,
        offsetToNative: 0.0,
      },
      {
        name: 'Mile',
        symbol: 'mi',
        aliases: ['mi', 'mile', 'miles'],
        isNativeUnit: false,
        factorToNative: 1609.34,
        offsetToNative: 0.0,
      },
      {
        name: 'Millimeter',
        symbol: 'mm',
        aliases: ['mm', 'millimeter', 'millimeters'],
        isNativeUnit: false,
        factorToNative: 0.001,
        offsetToNative: 0.0,
      },
      {
        name: 'Nanometer',
        symbol: 'nm',
        aliases: ['nm', 'nanometer', 'nanometers'],
        isNativeUnit: false,
        factorToNative: 1e-9,
        offsetToNative: 0.0,
      },
      {
        name: 'USSurveyInch',
        symbol: 'sIN',
        aliases: ['us-in', 'us-inch', 'us-inches', 'sin'],
        isNativeUnit: false,
        factorToNative: 0.0254000508001016,
        offsetToNative: 0.0,
      },
      {
        name: 'USSurveyFoot',
        symbol: 'sFT',
        aliases: ['ussurveyfoot', 'us-ft', 'us-foot', 'us-feet', 'usft', 'usfoot', 'usfeet', 'sft'],
        isNativeUnit: false,
        factorToNative: 0.3048006096012192,
        offsetToNative: 0.0,
      },
      {
        name: 'USSurveyYard',
        symbol: 'sYD',
        aliases: ['us-yd', 'us-yard', 'us-yards', 'syd'],
        isNativeUnit: false,
        factorToNative: 0.9144018288036575,
        offsetToNative: 0.0,
      },
      {
        name: 'USSurveyMile',
        symbol: 'sMI',
        aliases: ['us-mi', 'us-mile', 'us-miles', 'smi'],
        isNativeUnit: false,
        factorToNative: 1609.3472186944373,
        offsetToNative: 0.0,
      },
      {
        name: 'Yard',
        symbol: 'yd',
        aliases: ['yd', 'yard', 'yards'],
        isNativeUnit: false,
        factorToNative: 0.9144,
        offsetToNative: 0.0,
      },
    ],
  },
];
